/* eslint-disable no-constant-condition */
import React, { useState } from "react";
import { Flex, Loader } from "@fluentui/react-northstar";
import { Tab, TabList } from "@fluentui/react-tabs";
import TabAbout from "./TabAbout";
import TabIdentity from "./TabIdentity";
import { useEmployeeFolderIdUser, useEmployeeFolderIsMe } from "../../../store";
import { ROLES_CODE, roles_access } from "../../../../../constants/roles";
import TabContract from "./TabContract";
import { Container, ContainerFluid } from "../../../../../common/styles";
import { QUERY_KEY } from "../../../constants";
import { useQuery } from "react-query";
import { useAuthDetailStore } from "../../../../../stores/useAuthStore";
import { _api_get_about_informations } from "../../../api";
import TabTimetable from "./TabTimetable";
import { ALL_TABS } from "../../..";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";

const _displayTabsDependRoles = ({ isMe, isHR, isManager, manager_email }) => {
    const { detail } = useAuthDetailStore.getState();

    if (isMe || isHR || isManager) {
        const all_tabs_without_planning = [ALL_TABS.about, ALL_TABS.identity];
        if (isHR) {
            all_tabs_without_planning.push(
                ALL_TABS.contract,
                ALL_TABS.timetable
            );
        }
        if (isManager && manager_email === detail?.email) {
            const containTimetable = all_tabs_without_planning.includes(
                ALL_TABS.timetable
            );
            if (!containTimetable) {
                all_tabs_without_planning.push(ALL_TABS.timetable);
            }
        }
        return all_tabs_without_planning;
    }
    return [ALL_TABS.about];
};

const Body = ({ selectedValue, setSelectedValue }) => {
    const [_, setSearchParams] = useSearchParams();
    const isMe = useEmployeeFolderIsMe();
    const isHR = roles_access({
        usersPrivileges: [ROLES_CODE.hr],
    });
    const isManager = roles_access({
        usersPrivileges: [ROLES_CODE.manager],
    });

    const onTabSelect = (_, data) => {
        setSearchParams({ t: data.value });
        setSelectedValue(data.value);
    };

    const id_employee = useEmployeeFolderIdUser();

    // * queries
    const { data, isLoading, isFetching } = useQuery(
        [QUERY_KEY + "::about", id_employee],
        () => _api_get_about_informations(id_employee),
        {
            refetchOnWindowFocus: false,
        }
    );

    if (isLoading) {
        return (
            <ContainerFluid>
                <Container>
                    <Loader
                        label="chargement des données"
                        labelPosition="end"
                    />
                </Container>
            </ContainerFluid>
        );
    }

    const tabs = _displayTabsDependRoles({
        isMe,
        isHR,
        isManager,
        manager_email: data?.manager?.email, // for planning tab
    });

    return (
        <ContainerFluid column>
            <TabListStyle
                selectedValue={selectedValue}
                onTabSelect={onTabSelect}
            >
                <Container>
                    {tabs?.map((tab) => {
                        return (
                            <Tab id={tab.id} value={tab.id} key={tab.id}>
                                {tab.content}
                            </Tab>
                        );
                    })}
                </Container>
            </TabListStyle>
            <Container column fill>
                <Flex
                    styles={{
                        paddingBlock: "24px",
                        backgroundColor:
                            selectedValue === "timetable" ? "white" : "#f0f0f0",
                    }}
                >
                    {selectedValue === "about" && (
                        <TabAbout
                            data={data}
                            isLoading={isLoading}
                            isFetching={isFetching}
                        />
                    )}
                    {selectedValue === "identity" && <TabIdentity />}
                    {selectedValue === "contract" && <TabContract />}
                    {selectedValue === "timetable" && <TabTimetable />}
                </Flex>
            </Container>
        </ContainerFluid>
    );
};

export default Body;

const TabListStyle = styled(TabList)`
    border-bottom: 1px solid #d1d1d1;
    border-top: 1px solid #d1d1d1;
    background-color: #f5f5f5;
    width: 100%;
    overflow-x: scroll;
    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;
